"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.filterOutCurrentCategory = void 0;
const filterOutCurrentCategory = (param)=>{
    let { categories, pageId } = param;
    return (categories !== null && categories !== void 0 ? categories : []).filter((category)=>category !== null && category.landingPageId !== pageId);
};
exports.filterOutCurrentCategory = filterOutCurrentCategory;
